import { z } from "zod";

export const importedSettlementDisplaySchema = z.object({
    providerId: z.string().nullable(),
    paymentDateOnly: z.string().nullable(),
    cutoverDate: z.string(),
    amount: z.number(),
});

export type ImportedSettlementDisplay = z.infer<
    typeof importedSettlementDisplaySchema
>;

export const documentImportedSettlementsResponseSchema = z.object({
    settlements: z.array(importedSettlementDisplaySchema),
});
